import { jsx as _jsx } from "react/jsx-runtime";
// Fixed, full-width container overlaid on top of the header. Holds the app's
// top banners (permission-changed, export-in-progress). When more than one is
// active they render as a collapsed "deck" (top card in front, others peeking
// behind) and fan out vertically on hover - all CSS-driven (see
// _banner_stack.scss). Renders an empty (0-height) overlay when no banners.
export const BannerStack = ({ children }) => (_jsx("div", { className: "uxpcore_bannerstack", children: children }));
